<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-alert :value="true" v-if="error != null" type="error">{{
          error.message
        }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="signUp">
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="address1"
                  :rules="addressRules"
                  label="Address line 1"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="address2"
                  label="Address line 2"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="address3"
                  label="Address line 3"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="locality"
                  label="City / Town"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="region"
                  label="County / Region"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="postal_code"
                  :rules="addressRules"
                  label="Postal Code*"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-select
                  outline
                  :items="countries"
                  v-model="country"
                  item-text="name"
                  :rules="addressRules"
                  label="Country*"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <h2 class="heading-3 align-left">Interests</h2>
                <div class="body-copy">
                  <p>Please let us know your interests.</p>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs4 sm4> Who are your favourite players?
                  <p>
                    <br /> You can select up to 3 players across our men's, women's and legends' squads.
                  </p>
                  </v-flex>
                <v-flex xs3 sm3>
                  <v-select
                    :hide-details="true"
                    label="Select Squad"
                    :items="squads"
                    v-model="selectedSquad"
                    item-value="name"
                    outline
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs3 sm3>
                  <v-select
                    v-if="selectedSquad != null"
                    :hide-details="true"
                    label="Select Player"
                    :items="players"
                    v-model="selectedPlayer"
                    item-value="name"
                    outline
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.number }} {{ data.item.name }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs2 sm2>
                  <v-btn
                    icon
                    @click="addFavPlayer"
                    v-if="selectedPlayer != null"
                  >
                    <v-icon color="white">add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs4 sm4> </v-flex>
                <v-flex xs8 sm8>
                  <v-list>
                    <v-list-group
                      v-if="favPlayers.length"
                      v-model="playerListOpen"
                      append-icon=""
                    >
                      <v-list-tile
                        v-for="(player, index) in favPlayers"
                        :key="index"
                      >
                        <v-list-tile-content>
                          {{ player }}
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon @click="deleteFavPlayer(player)">
                            <v-icon color="white">delete</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list-group>
                    <v-list-tile v-else>
                      <v-list-tile-content></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            
            <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  Who do you attend matches at Celtic Park with?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-select
                    :hide-details="true"
                    label="Please select"
                    :items="metaAttendWithOptions"
                    v-model="metaAttendWithSelected"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  Do you have children who play football?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-select
                    :hide-details="true"
                    label="Please select"
                    :items="metaChildrenPlayOptions"
                    v-model="metaChildrenPlaySelected"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  Which official Celtic FC products are you interested in?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-checkbox
                    v-for="(option, index) in metaProductInterestOptions"
                    :key="index"
                    v-model="metaProductInterestSelected"
                    :label="option"
                    :value="option"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4> Which teams are most interested in? </v-flex>
                <v-flex xs12 sm8>
                  <v-checkbox
                    v-for="(option, index) in metaTeamInterestOptions"
                    :key="index"
                    v-model="metaTeamInterestSelected"
                    :label="option"
                    :value="option"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  What types of holidays are you interested in?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-checkbox
                    v-for="(option, index) in metaHolidayInterestOptions"
                    :key="index"
                    v-model="metaHolidayInterestSelected"
                    :label="option"
                    :value="option"
                  ></v-checkbox>
                </v-flex>
              </v-layout>


            <v-layout row align-center mx-1 py-0>
              <v-flex xs12 pb-0>
                <a v-on:click="skip" class="skip">Skip this stage</a>
              </v-flex>
              <v-flex xs12 pb-0>
                <button
                  type="submit"
                  class="button continue"
                  :disabled="!valid"
                >
                  Submit
                </button>
              </v-flex>
            </v-layout>
          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Registration",
  data() {
    return {
      valid: true,
      ssoid: "",
      addressRules: [(v) => !!v || "You must fill in this address field"],
      address1: "",
      address2: "",
      address3: "",
      locality: "",
      region: "",
      postal_code: "",
      country: "",
      address: null,
      countries: [],
      squads: [],
      players: [],
      playerListOpen: true,
      selectedSquad: null,
      selectedPlayer: null,
      favPlayers: [],
      error: null,
      loading: false,
      metaAttendWithOptions: [
        "With my children/grandchildren",
        "With other family members",
        "I don't attend matches at Celtic Park",
      ],
      metaAttendWithSelected: null,
      metaChildrenPlayOptions: [
        "Yes, my daughter(s)",
        "Yes, my son(s)",
        "No, I don't have children who play football",
        "I do not have children",
      ],
      metaChildrenPlaySelected: null,
      metaProductInterestOptions: [
        "Kits",
        "Training wear",
        "Casual clothing",
        "Adidas collections",
      ],
      metaProductInterestSelected: [],
      metaTeamInterestOptions: ["Mens", "Women", "Celtic B team"],
      metaTeamInterestSelected: [],
      metaHolidayInterestOptions: [
        "Activity",
        "Cruise",
        "Fly & Drive",
        "Luxury",
        "Staycation",
        "Winter Sport",
        "City",
      ],
      metaHolidayInterestSelected: [],
    };
  },
  created() {
    this.$getCurrentUserAttributes().subscribe((userData) => {
      this.ssoid = userData["sub"];
      this.address = JSON.parse(userData["address"]);
      if (typeof this.address.country !== "undefined") {
        this.country = this.address.country;
      }
      if (typeof this.address.postal_code !== "undefined") {
        this.postal_code = this.address.postal_code;
      }
    });
    fetch("/countries.json")
      .then((r) => r.json())
      .then(
        (json) => {
          this.countries = json.countries;
        },
        (response) => {
          console.log("Error loading json:", response);
        }
      );
    fetch("/squads.json")
          .then((r) => r.json())
          .then(
            (json) => {
              this.squads = json.squads;
              console.log("squads", this.squads);
            },
            (response) => {
              console.log("Error loading json:", response);
            }
          );
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate();
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate();
    },
    selectedSquad: function (val, oldVal) {
      var thisSquad = this.squads.find((squad) => squad.name === val);
      this.players = thisSquad.players;
    },
  },
  methods: {
    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    skip() {
      var attributesList = {
        "custom:address_skip": "true",
      };

      this.$updateAttributes(attributesList).subscribe(
        (response) => {
          console.log("skip address input successful");
          this.$router.push("/profile");
        },
        (err) => {
          console.log(err.message);
          this.error = err;
        }
      );
    },
    deleteFavPlayer(player) {
      console.log("Deleting player", player);
      this.favPlayers = this.favPlayers.filter((e) => e !== player);
    },
    addFavPlayer() {
      console.log("Adding player", this.selectedPlayer);
      if (this.favPlayers.length > 2) {
        console.log("Player list oif full");
      } else if (this.favPlayers.includes(this.selectedPlayer)) {
        console.log("Player already in fav list");
      } else {
        this.favPlayers.push(this.selectedPlayer);
        this.selectedPlayer = null;
      }
      console.log("Fav players", this.favPlayers);
    },
    crmXCMPush(username) {
      var crmXCMPushURL =
        process.env.VUE_APP_XCM_CRM_API + "/user/push/" + username;
      console.log("XCM push url", crmXCMPushURL);
      return axios({
        method: "get",
        url: crmXCMPushURL,
      });
    },
    complete(username) {
      console.log("completing");
      var vm = this;
      this.dataPush(username).then(function (results) {
        // console.log('CRM update results', results[0])
        // console.log('CRM update results', results[1])
        if (localStorage.completeRegistrationRedirect) {
          var redirect = localStorage.completeRegistrationRedirect;
          console.log(
            "redirecting to " + localStorage.completeRegistrationRedirect
          );
          localStorage.removeItem("completeRegistrationRedirect");
          window.location = redirect;
        } else {
          vm.$router.push("/confirm");
        }
      });
    },
    signUp(e) {
      e.preventDefault();
      this.loading = true;

      var attributesList = {
        //"given_name": firstName,
      };

      var street_address =
        this.address1 + "\n" + this.address2 + "\n" + this.address3;

      var address = {
        street_address: street_address,
        locality: this.locality,
        region: this.region,
        postal_code: this.postal_code,
        country: this.country,
      };
      attributesList["address"] = JSON.stringify(address);
      attributesList["custom:metadata"] = JSON.stringify({
          "fav_players": this.favPlayers,
          "attend_with": this.metaAttendWithSelected,
          "children_play": this.metaChildrenPlaySelected,
          "products": this.metaProductInterestSelected,
          "teams": this.metaTeamInterestSelected,
          "holidays": this.metaHolidayInterestSelected,
        })
      var vm = this;
      this.$updateAttributes(attributesList).subscribe(
        (response) => {
          vm.complete(this.ssoid);
        },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          console.log(err.message);
          vm.error = err;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped >
.password-notice {
  margin: 0 0 20px;
  padding: 0 0 40px;
  color: $core-grey;
  font-size: 15px;
  line-height: 22px;
  border-bottom: 1px solid $core-light-grey;
}

.v-input--switch__track.theme--light.error--text {
  color: rgba(0, 0, 0, 0.38) !important;
}
.v-input--selection-controls__ripple.error--text {
  color: $core-white !important;
}
.v-input--switch__thumb.theme--light.error--text {
  color: $core-lightest-grey !important;
}

.continue {
  float: right;
}

.skip {
  margin-top: 10px;
  float: left;
  color: green;
}

</style>